import React, { Component } from "react";
import Article from "../elements/Article";
import Resume from "../../../resume.json";

class Articles extends Component {
  constructor(props) {
    super();
    this.state = { articles: [] };
  }

  componentDidMount() {
    
    Resume.projects.forEach((element, index) => {
      console.log(element)
      this.state.articles.push(
        <div className="c_cize" key={index}>
          <Article
            key={index}
            title={element.title}
            url={element.url}
            image={element.cover_image}
            project_name={element.project_name}
            extract={element.description}
            project_image={element.project_image}
            project_description={element.project_description}
          />
        </div>
      );
    });
  }

  render() {
    return (
      <section className="section" id="project">
        <div className="container">
          <div className="content_title">Projects</div>
          <div className="row">{this.state.articles}</div>
        </div>
      </section>
    );
  }
}


export default Articles;
